
import { defineComponent, PropType } from 'vue';
import factory from '../Singles/Factory.vue';
import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockEvents } from '@/models/Blocks/block-events';
import { DeviceType } from "@/models/Blocks/Itens/Types/device-type";
export default defineComponent({
    components:{
        factory
    },
    props:{
        item:{
            type: BlockItem
        },
        margins:{
            type: Boolean,
            default: false
        },
        device:{
            type: Number as PropType<DeviceType>,
            default: DeviceType.mobile
        },
        className:{
            type: String,
            default: ''
        }
    },
    computed:{
        isDesktop(): boolean{
            return this.device == DeviceType.desktop;
        }
    },
    mounted(){
        BlockEvents.AddEventsListener(this);
    },
});
